<template>

  <div>
     <vs-row class="mb-3 ml-2" >
      <vs-button color="dark" disabled type="flat"><h5>Setting / </h5></vs-button>
     <vs-button type="flat" to="/user"> <h5>User</h5></vs-button>
     <vs-button  color="dark" disabled type="flat"><b><h5>/ Edit User</h5></b> </vs-button>
    </vs-row>
     <!-- <b-breadcrumb style="background-color: #ffffff; ">
    <b-breadcrumb-item active><h5>Setting</h5></b-breadcrumb-item>
    <b-breadcrumb-item to="/User"><h5>User</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>Edit User</h5></b-breadcrumb-item>
  </b-breadcrumb> -->
    

    <vs-row>
      <vs-col vs-lg="12">

     
      <vs-card style="border-radius: 20px;">
        <h4 class="mt-2"><b>Currently setting user: </b> {{ this.user.name }}</h4>
        <br />
        <vs-alert color="primary" icon="new_releases">
            Fields can not be empty please enter the data
          </vs-alert><br>
        

        <vs-row vs-w="12">
  <vs-col class="mt-3" vs-type="flex"  vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12" >
    <vs-input icon-no-border icon="person_outline" label-placeholder="Name" v-model="user.name"/>
  </vs-col>
  <vs-col class="mt-3" vs-type="flex"  vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
    <vs-input  icon-no-border icon="email" label-placeholder="Email" v-model="user.email"/>
  </vs-col>
  <vs-col class="mt-3" vs-type="flex"  vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
    <vs-input icon-no-border icon="alternate_email" label-placeholder="Line" v-model="user.line"/>
  </vs-col>
</vs-row>
<vs-row vs-w="12">
  <vs-col class="mt-3" vs-type="flex"  vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12" >
    <vs-input icon-no-border icon="account_circle" label-placeholder="Username" v-model="user.username"/>
  </vs-col>
  <vs-col class="mt-3" vs-type="flex"  vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
    <vs-input icon-no-border icon="lock" label-placeholder="Password" v-model="user.password"/>
  </vs-col>
   <vs-col class="mt-3" vs-type="flex"  vs-align="center" vs-lg="4" vs-sm="12" vs-xs="12">
     <vs-input v-if="user.admin==null" icon-no-border icon="description" label-placeholder="Role" v-model="textAdmin"/>
    <vs-input else icon-no-border icon="description" label-placeholder="Role" v-model="textUser"/>
  </vs-col>
 
</vs-row>




     
        <br />
<!--          
        <vs-button color="primary" type="border" @click="editusersent">Accept</vs-button>&nbsp;&nbsp;&nbsp;
        <vs-button color="danger" type="border" to="/User" @click="adduser.user='',adduser.pwd='',adduser.email='',adduser.name=''">Cancel</vs-button>
         -->
 <vs-row class="mt-3 mb-3" vs-w="12">
        <vs-col class="mt-2 " vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-button class="bts" color="success" type="filled"  @click="editusersent">Save</vs-button>
          <vs-button class="ml-2" color="dark" to="/User" @click="adduser.user='',adduser.pwd='',adduser.email='',adduser.name=''" type="flat">Cancel</vs-button>
        </vs-col>
      </vs-row>  
       
      </vs-card> </vs-col>
    </vs-row>
    <vs-row v-if="user.admin == 'poonsak.ngk' || user.admin == 'pao' ">
      <vs-prompt
       :active.sync="active"
       @cancel="active = false"
       @close="active = false"
       @accept="newrole"
       class="dialog">
       Role Name
       <vs-input v-model="rolename" /><br>
       <h5>Permission</h5><br>
        <vs-row>
          <vs-col vs-lg="12" vs-sm="12" vs-xs="12" v-for="(item,i) in tabledata" :key="i">
            <vs-checkbox 
            v-model="checkarray4"
            :vs-value="item.name"
            style="justify-content: start; padding-bottom: 5%">{{item.name}}</vs-checkbox>
          </vs-col>
        </vs-row>
      </vs-prompt>
      <vs-col vs-lg="12" vs-xs="12">
        <vs-card >
          <vs-row><vs-col vs-lg="8" vs-sm="6"><h4>Light Control Permission</h4></vs-col>
          <vs-col vs-lg="4" vs-sm="6" vs-type="flex" vs-justify="flex-end">
          <vs-button type="filled" @click="active = true">Add Role</vs-button>
          </vs-col></vs-row><br>
          <h5>Select Role</h5>
          <vs-select
            class="selectExample"
            v-model="select1"
            @change="test()"
            >
            <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in options1"/>
          </vs-select><br>
          <vs-textarea
                label="Tooltip"
                width="100%"
                readonly
                v-model="text3"
              />
          <vs-row>
          <vs-col vs-lg="3" vs-sm="6" vs-xs="12" v-for="(item,i) in tabledata" :key="i">
            <vs-checkbox 
            v-model="checkarray3"
            :vs-value="item.name"
            style="justify-content: start; padding-bottom: 5%">{{item.name}}</vs-checkbox>
          </vs-col>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>
    <vs-row v-else>
      <vs-col vs-lg="6" vs-xs="12">
        <vs-card style="border-radius: 20px;" >
          <vs-row>
          <h4 class="mt-2">View Location Permission</h4><vs-spacer />
          <!-- <vs-button color="warning" type="line" to="/permission">
            <span><vs-icon icon="create"  ></vs-icon></span>Edit Role</vs-button> -->
          </vs-row>
          <br />
          <vs-row style="align-items: center;">
            <a style="font-size: 14px;">Select :</a> <vs-spacer />
            <vs-button color="success" type="flat" icon="done"
              >Select All</vs-button
            >
            <vs-button color="danger" type="flat" icon="clear"
              >Clear All</vs-button
            >
          </vs-row>
          <vs-row>
            <vs-col vs-lg="4" vs-xs="12">
              <vs-row v-for="item in treelist" :key="item.id">
                <vs-checkbox
                  v-model="checkarray1"
                  :vs-value="item"
                  style="justify-content: start; padding-bottom: 5%"
                  color="#333f50"
                  >{{ item }}</vs-checkbox
                >
              </vs-row>
            </vs-col>
            <vs-col vs-lg="8" vs-xs="12">
              <vs-textarea
                label="Tooltip"
                width="100%"
                readonly
                v-model="text"
              /> </vs-col
            ><vs-row vs-justify="flex-end">
              <vs-button type="filled" color="#333f50" @click="saveview"
                >Save Location Permission</vs-button
              >
            </vs-row>
          </vs-row>
        </vs-card>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <vs-card style="border-radius: 20px;">
          <vs-row class = "mt-2">
          <h4>Edit Location Permission</h4><vs-spacer />
          <!-- <vs-button color="warning" type="line" to="/permission">
            <span><vs-icon icon="create"  ></vs-icon></span>Edit Role</vs-button> -->
          </vs-row>
          <br />
          <vs-row style="align-items: center;">
            <a style="font-size: 14px;">Select :</a> <vs-spacer />
            <vs-button color="success" type="flat" icon="done"
              >Select All</vs-button
            >
            <vs-button color="danger" type="flat" icon="clear"
              >Clear All</vs-button
            >
          </vs-row>

          <vs-row>
            <vs-col vs-lg="4" vs-xs="12">
              <vs-row v-for="item in treelist" :key="item.id">
                <vs-checkbox
                  v-model="checkarray2"
                  :vs-value="item"
                  style="justify-content: start; padding-bottom: 5%"
                  color="#333f50"
                  >{{ item }}</vs-checkbox
                >
              </vs-row>
            </vs-col>
            <vs-col vs-lg="8" vs-xs="12">
              <vs-textarea
                label="Tooltip"
                width="100%"
                readonly
                v-model="text2"
              /></vs-col>
              <vs-row vs-justify="flex-end">
              <vs-button type="filled" color="#333f50" @click="saveedit"
                >Save Location Permission</vs-button
              >
            </vs-row>
          </vs-row>
        </vs-card>
      </vs-col>
    </vs-row>
    <!-- <p>{{this.user}}</p>
    <p>{{this.treelist}}</p>
    <p>{{this.checkarray1}}</p>
    <p>{{this.checkarray2}}</p> -->
  </div>
</template>
<script>
export default {
  name: "permissionsetting",
  props: ["user"],
  data: () => ({
    active: false,
    sensorlist: [],
    tabledata: [],
    treelist: [],
    textAdmin: 'Admin',
    textUser: 'User',
    checkarray1: [],
    checkarray2: [],
    checkarray3: [],
    checkarray4: [],
    rolelist: [],
    rolename: '',
    controlperm: [],
    select1: 'Custom',
    options1: ['Custom'],
    text: "This user will see Selected Location",
    text2: "This user will have permission to edit Selected Location",
    text3: 'This User can View & Edit selected zone'
  }),
  watch: {
    select1watch() {
      // console.log(this.select1)
    }
  },
  methods: {
    saveview() {
      this.$http
        .post(this.$url + "saveview", {
          headers: {
            "Access-Control-Request-Method": "*",
            "Access-Control-Request-Headers": "*",
            Origin: "*",
          },
          savelist: this.checkarray1,
          user: this.user,
        })
        .then((result) => {
          if (result) {
            this.$vs.notify({
              title: "Save Location",
              text: "Successful!",
              color: "success",
              position: "top-center",
              icon: "check",
            });
          }
        })
        .catch((err) => {
          if (err) {
            this.$vs.notify({
              title: "Save Location was unsuccessful",
              text: "Something wrong.",
              color: "danger",
              position: "top-center",
              icon: "clear",
            });
          }
        });
    },
    editusersent() {
      // console.log(this.user)
      this.active = false
      this.$http.post(this.$url+'updateaccount', {
        headers: {
                  'Access-Control-Request-Method': '*',
                  'Access-Control-Request-Headers': '*',
                  'Origin': '*'
                },
          name: this.user.name,
          username: this.user.username,
          password: this.user.password,
          email: this.user.email,
          admin: this.$session.get('username'),
          permission: ['All'],
          controlperm: this.checkarray3,
          id: this.user.id
      }).then((result) => {
        if(result) {
          this.$vs.notify({
            title: "Edit",
            text: "Successful!",
            color: "success",
            position: "top-center",
            icon: 'check'
          });
          setTimeout(() => {
            this.$router.push({name:'User'})
          }, 300);
        }
      }).catch((err) => {
        if(err) {
          this.$vs.notify({
            title: "Edit was unsuccessful",
            text: "Something wrong.",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }
      })
    },
    test() {
      // // console.log(this.select1,this.checkarray3)
      this.rolelist.forEach(element => {
        if(this.select1 == element.name)
        this.checkarray3 = element.permlist
      });
    },
    newrole() {
      // console.log(this.user)
      this.$http.post(this.$url+'role', {
        headers: {
                  'Access-Control-Request-Method': '*',
                  'Access-Control-Request-Headers': '*',
                  'Origin': '*'
                },
          name: this.rolename,
          perm: this.checkarray4,
          token: this.$session.get('token')
      }).then((result) => {
        if(result) {
          this.$vs.notify({
            title: "Add Role",
            text: "Successful!",
            color: "success",
            position: "top-center",
            icon: 'check'
          });
          setTimeout(() => {
            this.$router.push({name:'User'})
          }, 300);
        }
      }).catch((err) => {
        if(err) {
          this.$vs.notify({
            title: "Edit was unsuccessful",
            text: "Something wrong.",
            color: "danger",
            position: "top-center",
            icon: 'clear'
          });
        }
      })
    },
    saveedit() {
      this.$http
        .post(this.$url + "saveedit", {
          headers: {
            "Access-Control-Request-Method": "*",
            "Access-Control-Request-Headers": "*",
            Origin: "*",
          },
          editlist: this.checkarray2,
          user: this.user,
        })
        .then((result) => {
          if (result) {
            this.$vs.notify({
              title: "Edit Location",
              text: "Successful!",
              color: "success",
              position: "top-center",
              icon: "check",
            });
          }
        })
        .catch((err) => {
          if (err) {
            this.$vs.notify({
              title: "Edit Location was unsuccessful",
              text: "Something wrong.",
              color: "danger",
              position: "top-center",
              icon: "clear",
            });
          }
        });
    },
  },
  mounted() {
    this.$http.get(this.$url+'role/'+this.$session.get('token'))
    .then((result) => {
      this.rolelist = result.data
      // console.log(this.rolelist)
      this.rolelist.forEach(element => {
        this.options1.push(element.name)
        if(element.permlist = this.user.controlperm) {
          this.select1 = element.name
        }
      });
    })
    // console.log(this.user);
    if(this.user.controlperm) {
      this.checkarray3 = this.user.controlperm
    }else{
      this.checkarray3 = []
    }
    this.$http.get(this.$url + "getTreeList/" + this.user.admin)
    .then((result) => {
      this.treelist = result.data[0];
      // eslint-disable-next-line no-console
      // console.log(this.treelist);
    });
    this.$http.post(this.$url + "adminsensor", {
      admin: this.user.admin
    })
    .then((result) => {
      // console.log(result.data)
      result.data.forEach(element => {
        if(element.lastdata)
        this.sensorlist.push(JSON.parse(element.lastdata[0]))
      });
      this.sensorlist.forEach(element => {
        Object.keys(element).forEach(rack => {
          this.tabledata.push({name:rack})
        });  
      });
      // console.log(this.sensorlist);
    });
    // this.$http.get(this.$url + "getAdmin/" + this.user.admin).then((result) => {
    //   this.admin = result.data[0];
    //   this.checkarray1 = result.data[0].viewperm || [];
    //   this.checkarray2 = result.data[0].editperm || [];
    //   // console.log(this.admin);
    // });
  },
};
</script>
<style  scoped>
.vs-button{
  border-radius: 20px;
}
.vs-input{
  width: 250px;
  border-radius: 20px;
}
.bts{
  width: 70px;
  border-radius: 18px;
}
</style>
